export default "__VITE_ASSET__DUngomug__"